import axios from 'axios';
import { matchBackend } from '@lendica/utils';
import { v2 } from '@lendica/api';
import type { UserCompanyStatusResponse } from './types';

const v2BaseURL = matchBackend('v2');

export const listMemberships = async () => {
    const response = await axios.get(`${v2BaseURL}/client/memberships/list`);
    return v2.unwrap(response.data);
};

export const getCompanyDetails = async (companyId: string) => {
    const response = await axios.get(`${v2BaseURL}/client/companies/${companyId}/companies/detail`);
    return v2.unwrap(response.data);
};

/**
 * Get the status for the authenticated user within the given company.
 * Centralizes the post-auth metadata the frontend needs before showing the main dashboard experience.
 *
 * @param companyId - UUID for the company currently in scope
 * @returns The response payload containing company + user status fields
 */
export const getUserCompanyStatus = async (
    companyId: string
): Promise<UserCompanyStatusResponse> => {
    const response = await axios.get<UserCompanyStatusResponse>(
        `${v2BaseURL}/client/companies/${companyId}/user_status`
    );
    return response.data;
};
